export default "__VITE_ASSET__D1ycPaH1__"